import { combineReducers } from 'redux';

import {
    BonusSettlementDetailReducerState,
    bonusSettlementDetailReducer,
} from '../detail/store/bonus-settlements-detail-reducer';
import {
    BonusSettlementDetailSidebarReducerState,
    bonusSettlementDetailSidebarReducer,
} from './sidebar-store/bonus-settlements-detail-sidebar-reducer';
import {
    BonusSettlementsOverviewReducerState,
    bonusSettlementsOverviewReducer,
} from '../overview/store/bonus-settlements-overview-reducer';

export interface BonusSettlementsReducerState {
    overview: BonusSettlementsOverviewReducerState;
    detail: BonusSettlementDetailReducerState;
    settings: BonusSettlementDetailSidebarReducerState;
}

export const bonusSettlementsReducer = combineReducers<BonusSettlementsReducerState>({
    overview: bonusSettlementsOverviewReducer,
    detail: bonusSettlementDetailReducer,
    settings: bonusSettlementDetailSidebarReducer,
});
